import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useState } from "react";
import Layout from "../../components/Layout/Layout";
import { AppBar, Button, Grid, IconButton } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import PedidosEnviados from "./PedidosEnviados";
import PedidosEnPreparacion from "./PedidosEnPreparacion";
import PedidosPendientesDePago from "./PedidosPendientesDePago";
import PedidosCancelados from "./PedidosCancelados";
import PedidosEnValidacion from "./PedidosEnValidacion";
import PaymentInfo from "./PaymentInfo";
import { BackIcon } from "../../components/icons/BackIcon";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function IndexPedidos(props) {
  const [value, setValue] = useState(0);
  const history = useHistory();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Layout>
      <Grid container spacing={2} sx={{ padding: 2 }}>
        <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
          <Typography
            textAlign='center'
            fontWeight='bold'
            fontSize='25px'
            color='#ffa489'
          >
            Mis pedidos
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <IconButton aria-label='' onClick={() => props.history.goBack()}>
            <BackIcon />
          </IconButton>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          display='flex'
          justifyContent='center'
        >
          <Box sx={{ bgcolor: "background.paper", width: "100%" }}>
            <AppBar position='static'>
              <Tabs
                value={value}
                onChange={handleChange}
                //indicatorColor="secondary"
                textColor='secondary'
                //centered
                variant='scrollable'
                scrollButtons
                allowScrollButtonsMobile
                aria-label='scrollable force tabs example'
                sx={{ backgroundColor: "#ffa489" }}
              >
                <Tab label='Pedidos Pendientes de pago' {...a11yProps(0)} />
                <Tab label='Pedidos en validacion de pago' {...a11yProps(1)} />
                <Tab label='Pedidos En preparación' {...a11yProps(2)} />
                <Tab label='Pedidos Enviados' {...a11yProps(3)} />
                <Tab label='Pedidos Cancelados' {...a11yProps(4)} />
              </Tabs>
            </AppBar>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TabPanel value={value} index={3}>
            <PedidosEnviados />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <PedidosEnPreparacion />
          </TabPanel>
          <TabPanel value={value} index={0}>
            <PedidosPendientesDePago />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <PedidosCancelados />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <PedidosEnValidacion />
          </TabPanel>
        </Grid>
      </Grid>
      <PaymentInfo open={open} handleClose={handleClose} />
    </Layout>
  );
}
